
function myToggleSiteMenu() {
    var element2 = document.getElementById("navOverlay");
    element2.classList.toggle("showMe");
}

function closeSiteNav() {
    myToggleSiteMenu();
}

function myToggleMenu() {
    var element = document.getElementById("toggleMenu");
    element.classList.toggle("showToggleMenu");
}

// Home slider JS start
var galleryTop = new Swiper('.homeSlider', {
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: '.swiper-paginationhome',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-home-next',
        prevEl: '.swiper-button-home-prev',
    },
    breakpoints: {
        990: {
            slidesPerView: 1,
            slidesPerGroup: 1
        }
    },
});

$(document).ready(function(){
    $('.cross-icon').click(function(){
        //$('.headerCovid').slideToggle('slow');
        $('.headerCovid').hide('slow');
    });
});

galleryTop.on('slideChangeTransitionEnd', function () {

    var activeIndex = this.realIndex; // correct index

    var bullets = document.querySelectorAll('.swiper-paginationhome .swiper-pagination-bullet');

    if (!bullets.length) return;

    bullets.forEach(function (bullet) {
        if (activeIndex === 3) { // 4th slide
            bullet.style.backgroundColor = 'black';
        } else {
            bullet.style.backgroundColor = 'white';
        }
    });

});
$('.toggleMenu, .mainNavHeader .closeMe').on('click', function(){
    $('body').toggleClass('showMainNav');

    if (document.documentElement.clientWidth <= 990) {
        $('.mainNavList > .ddYes .toggleSubMenu').on('click', function (e) {

            var curStatus = $(this).parents('li').attr('class');

            if(curStatus !== 'ddYes show'){
                $('.mainNavList > li').removeClass('show');
                $(this).parents('li').addClass('show');
                // $('.mainNavList').animate({
                //     scrollTop: $(this).offset().top -50
                // }, 1000);
            }else{
                $(this).parents('li').removeClass('show');
            }

            e.preventDefault();

        });

        $('*').on('click', function (e) {
            // console.log(e.target.className);
            if (e.target.className === "megamenuWapper showMegamenu") {
                $('.megamenuWapper').removeClass('showMegamenu');
                $('body').removeClass('mobScrollNone');
            }
        });

        $(".megamenuWapper").swipe({
            swipeLeft: function (event, direction, distance, duration, fingerCount, fingerData) {
                $(this).removeClass('showMegamenu');
                $('body').removeClass('mobScrollNone');
            }
        });
    }
});
if (document.documentElement.clientWidth <= 990) {
    $('.rolexNavList > li.dropDownclick > a').click(function(){
        $('.dropdown-menu').toggleClass('showNav')
    })
}



// Keep exploring JS start
var swiper = new Swiper('.swiper-container', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 8,
    loopFillGroupWithBlank: false,
    lazy: {
        loadPrevNext: true,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: false,

    breakpoints: {
        0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 4
        },

        768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 4
        },

        990: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 6
        }
    },
});


// Bottom to top scroll
$(".bottomTop").click(function() {
    $("html").animate({ scrollTop: 0 }, "slow");
});

// Nav JS start here
if ($(window).width() <= 992) {
    $('.btnNavToggle').click(function() {
        $('nav').toggleClass('showMainNav');
        $('body').toggleClass('scrollNone');
    });
    $('nav').click(function() {
        $(this).removeClass('showMainNav');
        $('body').removeClass('scrollNone');
    });
    $('.navication').click(function(event) {
        event.stopPropagation();
    });

    $('nav ul li a.mainLinks').click(function() {
        var $this = $(this);
        if ($this.next().hasClass('showdrop')) {
            $this.next().removeClass('showdrop');
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('.megamenuWapper').removeClass('showdrop');
            $this.parent().parent().find('.megamenuWapper').slideUp(350);
            $this.next().toggleClass('showdrop');
            $this.next().slideToggle(350);
        }
    });

    };

    $(document).ready(function() {  
        if ($(window).width() <= 980) {   
               $('.navication').click(function(event){
                   event.stopPropagation();
               }); 
       
               $('.btnNavToggle,  .navTitle .btnNavToggleNew').click(function(){
                   $('.subMenu').removeClass('showDropDown')
       
               })
       
               $('nav .navication .mainTitle ').click(function(){
                   $('.subMenu').removeClass('showDropDown')            
       
               })
       
       
       
               $('.mainNavList > li > a').click(function() {            
                   var $this = $(this); 
                   if ($this.next().hasClass('showdrop')) {
                       $this.next().removeClass('showdrop');
                       $this.next().slideUp(350); 
                   } else {
                       $this.parent().parent().find('.megamenuWapper').removeClass('showdrop');
                       $this.parent().parent().find('.megamenuWapper').slideUp(350);
                       $this.next().toggleClass('showdrop');
                       $this.next().slideToggle(350);
                   }
       
               });  
               $('.navCatList li a') .click(function(){
                   $ (this).next('.navCatChildList').toggleClass('showSubcategery')
               })
               $('.closeDropdown, .btnNavToggle') .click(function(){
                   $('.navCatChildList').removeClass('showSubcategery')
               })
                $(".dropdown-a").removeAttr("href");
       
           }
           });
           
           
           
           $(".mobileMenu").on("click", function() {
           if ($(this).hasClass("active")) {
             $(this).removeClass("active");
             $(this)
               .siblings(".ftpNav")
               .slideUp(200);
             
           } else {
             
             $(this)
               
             $(".mobileMenu").removeClass("active");
             $(this).addClass("active");
             $(".ftpNav").slideUp(200);
             $(this)
               .siblings(".ftpNav")
               .slideDown(200);
           }
         }); 

$(document).ready(function() {
    $('.closeInfoBar').click(function() {
        $('.headerInfoBar').slideToggle('slow');
    });
});

$('#bookAnappointment .homeContactBlock label').click(function() {
    $('#bookAnappointment.tab-pane').removeClass('active');
    $('#please-note').addClass('active show');
});

      
